// Routes an agent may access when the account has `allow_agent_self_reports` enabled.
// Data on these pages is filtered down to the agent's own row.
export const AGENT_SELF_REPORT_ROUTES = [
  'agent_reports',
  'account_call_analytics',
];

export default { AGENT_SELF_REPORT_ROUTES };
